export const recruitmentData = [
  {
    jobPositionType: 0, // 0 社招, 1校招实习
    jobType: 2, // 0研发 1 产品 2 市场运营
    city: 0, // 0 深圳 1其他
    title: "新媒体运营",
    tip: "市场/运营",
    sources: "社招",
    jobBenefits: "五险一金、节假日福利、带薪年假、定期体检、团建聚餐",
    jobResponsibilities:
      "1、根据品牌/产品特色与运营推广节奏，制定短视频内容的整体规划、策划、执行和监控；\n2、负责公司品牌/产品相关短视频号的日常运营，包括但不限于：账号内容策划、脚本撰写、对品牌/产品曝光量及新增有效线索数负责；\n3、进行短视频平台KOL/KOC的拓展，并建立良好的合作机制；\n4、根据用户体验，优化运营策略，展现品牌和产品调性，把控热点，提升转化率。",
    jobRequirements:
      "1、全日制统招本科及以上学历，法律或新闻类专业，有独立策划、拍摄、后期制作、运营短视频自媒体经验者优先；\n2、熟悉各视频平台规则，了解投流机制和玩法，对各渠道平台用户属性有较深的了解，能针对用户分层属性设计传播方案及活动；\n3、具备出色的创意内容能力和文字功底，对数据高敏感性，有较强的数据分析能力，能从数据中发现规律并优化策略\n4、熟练掌握PR/PS/剪映等专业工具；\n5、自驱力及沟通能力强，工作态度认真负责，抗压能力强，团队合作意识强；\n6、有法律行业从业经验或了解法律行业者优先。",
    applicationMethod: "简历投递邮箱：dlhr@delilegal.com（投递时请备注：投递岗位+姓名+学校）",
  },
  {
    jobPositionType: 1, // 0 社招, 1校招实习
    jobType: 2, // 0研发 1 产品 2 市场运营
    city: 0, // 0 深圳 1其他
    title: "用户运营",
    tip: "市场/运营",
    sources: "校招 (实习生)",
    jobBenefits: "五险一金、节假日福利、带薪年假、定期体检、团建聚餐",
    jobResponsibilities:
      "1、负责用户日常管理，包括用户维护、用户增长等\n2、收集用户意见，与用户进行有效沟通，了解用户需求和反馈",
    jobRequirements:
      "1、教育背景：本科以上学历，市场营销、法学专业优先；\n2、学习能力：有快速学习的能力，熟悉用户运营基本理论及逻辑；\n3、沟通协作：具备优秀的沟通和协作能力；\n4、责任心：有责任心和执行力，善于学习和独立思考。",
    applicationMethod: "简历投递邮箱：dlhr@delilegal.com（投递时请备注：投递岗位+姓名+学校）",
  },
  {
    jobPositionType: 1, // 0 社招, 1校招实习
    jobType: 2, // 0研发 1 产品 2 市场运营
    city: 0, // 0 深圳 1其他
    title: "内容运营",
    tip: "市场/运营",
    sources: "校招 (实习生)",
    jobBenefits: "五险一金、节假日福利、带薪年假、定期体检、团建聚餐",
    jobResponsibilities: "在微信、小红书、知乎、百家号等渠道通过内容对品牌和产品进行曝光、种草，建立用户认知",
    jobRequirements:
      "1、教育背景：本科生或以上学历，市场营销、传媒类、法学类专业优先；\n2、自媒体经验：有个人自媒体账号运营经验，熟悉互联网内容的输出模式，对AI、法律、saas产品等某个垂直领域有较深入的关注；\n3、数据分析：具备一定的数据分析能力，能够通过数据来优化内容运营策略；\n4、责任心：有责任心和执行力，善于学习和独立思考。",
    applicationMethod: "简历投递邮箱：dlhr@delilegal.com（投递时请备注：投递岗位+姓名+学校）",
  },
  {
    jobPositionType: 1, // 0 社招, 1校招实习
    jobType: 2, // 0研发 1 产品 2 市场运营
    city: 0, // 0 深圳 1其他
    title: "媒介BD",
    tip: "市场/运营",
    sources: "校招 (实习生)",
    jobBenefits: "五险一金、节假日福利、带薪年假、定期体检、团建聚餐",
    jobResponsibilities:
      "在微信、小红书、抖音等渠道筛选适合产品调性及对应领域的KOL/KOC，建立合作关系，利用短视频、笔记、公众号推文等形式的UGC内容进行产品的推荐，进行产品的破圈及种草",
    jobRequirements:
      "1、教育背景：本科生或以上学历，市场营销、传媒类、法学类专业优先；\n2、沟通协调：具备较强的沟通及表达能力，能深入挖掘潜在资源，进行深度合作；\n3、学习能力：良好的学习能力，熟悉自媒体，了解KOC/KOL运作规律更佳。",
    applicationMethod: "简历投递邮箱：dlhr@delilegal.com（投递时请备注：投递岗位+姓名+学校）",
  },
  {
    jobPositionType: 0, // 0 社招, 1校招实习
    jobType: 2, // 0研发 1 产品 2 市场运营
    city: 0, // 0 深圳 1其他
    title: "客户成功",
    tip: "市场/运营",
    sources: "社招",
    jobBenefits: "五险一金、节假日福利、带薪年假、定期体检、团建聚餐",
    jobResponsibilities:
      "1、负责客户的业务指导与咨询工作，洞察客户需求，深入客户业务场景，制定客户成功计划，通过产品赋能以及运营方案，为客户提供业务解决方案，帮助客户实现数字化升级以及降本增效的目标；\n2、负责客户的全生命周期管理，包括日常答疑、咨询跟进、问题处理、培训提升等工作，提升客户活跃度与满意度；\n3、与客户保持良好沟通，结合客户业务流程和系统使用情况，快速判断定位问题所在，解决痛点，促进续费增购，进行客情维护。",
    jobRequirements:
      "1、本科及以上学历，市场营销、法学、计算机、管理类相关专业优先；\n2、有客户成功相关工作经验者优先；\n3、对于法律科技行业有一定兴趣，乐于研究先进软件工具，了解数字化转型大趋势；\n4、具备较强的沟通表达能力、组织协调能力和执行能力，能够高效响应和及时解决问题；\n5、具备良好的服务意识和自驱力，积极主动，责任心强。",
    applicationMethod: "简历投递邮箱：dlhr@delilegal.com（投递时请备注：投递岗位+姓名+学校）",
  },
  {
    jobPositionType: 0, // 0 社招, 1校招实习
    jobType: 1, // 0研发 1 产品 2 市场运营
    city: 0, // 0 深圳 1其他
    title: "产品经理",
    tip: "产品",
    sources: "社招",
    jobBenefits: "五险一金、节假日福利、带薪年假、定期体检、团建聚餐",
    jobResponsibilities:
      "1、负责法律科技行业的市场分析、用户调研、产品机会发现、总体解决方案设计和产品功能设计；\n2、负责SaaS法律平台的APP、小程序和web产品的独立迭代，规划产品版本，输出产品文档、交互原型和业务逻辑，协调合作团队的资源，保障产品交付质量；\n3、学习国内外行业内优秀的解决方案，通过竞品分析发现机会与问题点，通过运营数据持续优化产品体验，打造竞争优势。",
    jobRequirements:
      "1、本科以上学历，3年以上互联网产品经理经验，有法律、SaaS类产品经验优先；\n2、对AI的应用场景有比较深刻的理解和思路优先；\n3、有平台产品策划经验，并完整独立负责过重要模块，对所做产品有自己的独立见解，对用户体验敏感；\n4、学习能力强，具备良好的沟通协作能力和团队合作意识，自我驱动力强；\n5、对法律科技行业有兴趣，愿意持续在这条路上探索和创造；\n6、具备良好的沟通、表达和文字能力：能够线下给客户介绍产品、编写产品软文。",
    applicationMethod: "简历投递邮箱：dlhr@delilegal.com（投递时请备注：投递岗位+姓名+学校）",
  },
  {
    jobPositionType: 1, // 0 社招, 1校招实习
    jobType: 1, // 0研发 1 产品 2 市场运营
    city: 0, // 0 深圳 1其他
    title: "产品实习生",
    tip: "产品",
    sources: "校招 (实习生)",
    jobBenefits: "五险一金、节假日福利、带薪年假、定期体检、团建聚餐",
    jobResponsibilities: "法律相关软件产品需求原型设计、需求文档（Web\\App\\小程序） ",
    jobRequirements:
      "1、软件工程或计算机应用相关专业本科以上学历；\n2、负责法律科技行业的市场分析、用户调研、产品机会发现、解决方案设计和产品功能设计；\n3、负责SaaS法律平台的APP、小程序和web产品的迭代，输出产品文档、交互原型和业务逻辑保障产品交付质量；\n4、学习国内外行业内优秀的解决方案，通过竞品分析发现机会与问题点，通过运营数据持续优化产品体验，打造竞争优势；\n5、对产品有自己的独立见解，对用户体验敏感；\n6、学习能力强，具备良好的沟通协作能力和团队合作意识，自我驱动力强。 ",
    applicationMethod: "简历投递邮箱：dlhr@delilegal.com（投递时请备注：投递岗位+姓名+学校）",
  },
  {
    jobPositionType: 1, // 0 社招, 1校招实习
    jobType: 1, // 0研发 1 产品 2 市场运营
    city: 0, // 0 深圳 1其他
    title: "软件UI交互设计",
    tip: "产品",
    sources: "校招 (实习生)",
    jobBenefits: "五险一金、节假日福利、带薪年假、定期体检、团建聚餐",
    jobResponsibilities: "基于软件产品原型进行UI交互设计",
    jobRequirements:
      "1、本科及以上学历，设计类专业；\n2、对设计趋势有敏锐的感知能力，巧妙运用视觉要素，善于发挥视觉创意和表现力；\n3、具备良好的沟通能力和团队协作精神，对用户体验和设计触达有一定敏感度，学习能力强。",
    applicationMethod: "简历投递邮箱：dlhr@delilegal.com（投递时请备注：投递岗位+姓名+学校）",
  },
  {
    jobPositionType: 0, // 0 社招, 1校招实习
    jobType: 2, // 0研发 1 产品 2 市场运营
    city: 0, // 0 深圳 1其他
    title: "广告策划投放",
    tip: "市场/运营",
    sources: "社招",
    jobBenefits: "五险一金、节假日福利、带薪年假、定期体检、团建聚餐",
    jobResponsibilities:
      "1、负责对公司产品广告宣传方案的制定，实施和跟踪；\n2、参与设计、审核广告宣传素材，提出创意性思维和改善性意见；\n3、熟悉网络文化，可追热点进行内容的撰写落地，包含但不限于H5、视频脚本、文稿；\n4、承担品牌团队创意脑爆的组织者，有对品牌课题长线运营思维并整合脑爆创意内容；\n5、对接广告代理或平台（腾讯、抖音、百度、小红书等），实时沟通广告效果反馈，优化广告推广效果；\n6、分析广告投放数据，提交数据分析报告，给出优化建议，提升广告链路各项指标。",
    jobRequirements:
      "1、本科及以上学历，市场营销、汉语言文学、新闻传播等相关专业优先；\n2、3年以上相关广告策划从业经验者；\n3、有过和抖音腾讯百度小红书等平台广告合作经验，熟悉各平台投流政策，优化策略，审核机制，有在上述各平台广告渠道部经验优先，有广告代理平台相关经验优先；\n4、自我要求高，遇到问题以正面视角进行评估及找到有效解决办法；\n5、沟通能力强，能团队合作也能担当主力，能够严格的进行项目时间把控，执行力和思考力具佳。",
    applicationMethod: "简历投递邮箱：dlhr@delilegal.com（投递时请备注：投递岗位+姓名+学校）",
  },
  {
    jobPositionType: 1, // 0 社招, 1校招实习
    jobType: 0, // 0研发 1 产品 2 市场运营
    city: 0, // 0 深圳 1其他
    title: "数据分析",
    tip: "研发",
    sources: "校招 (实习生)",
    jobBenefits: "五险一金、节假日福利、带薪年假、定期体检、团建聚餐",
    jobResponsibilities: "大数据处理、分析及数据挖掘",
    jobRequirements:
      "1、23届、24届毕业生，计算机数据科学与大数据相关专业，应用数学、统计学、应用经济学、运筹学等数据科学相关专业；\n"+
      "2、扎实的专业知识，严谨的逻辑思维能力；\n"+
      "3、熟练使用python/R/matlab等相关统计学软件；\n"+
      "4、较强的动手能力，有学术研究成果发表者优先。\n"+
      "5、了解并具备使用主流AI大模型工具；有将 LLM 集成到工作中的实践经验者优先",
    applicationMethod: "简历投递邮箱：dlhr@delilegal.com（投递时请备注：投递岗位+姓名+学校）",
  },
  {
    jobPositionType: 1, // 0 社招, 1校招实习
    jobType: 0, // 0研发 1 产品 2 市场运营
    city: 0, // 0 深圳 1其他
    title: "NLP算法工程师",
    tip: "研发",
    sources: "校招 (实习生)",
    jobBenefits: "五险一金、节假日福利、带薪年假、定期体检、团建聚餐",
    jobResponsibilities: "语义检索优化、大模型指令调优等相关研究任务",
    jobRequirements:
      "1、计算机、信息工程、人工智能、软件工程、统计学、应用数学等专业的博士和优秀硕士；\n"+
      "2、熟练掌握NLP基础理论和算法，在一个或多个领域（如对话系统、文本分类、语义理解、知识图谱构建、篇章理解、情感分析、自然语言生成等）能够独立开展研发工作；\n"+
      "3、熟悉至少一种编程语言，包括但不限于java、python、c++等；\n"+
      "4、熟练使用一种或几种深度学习框架（如tensorflow、pytorch等）；\n"+
      "5、在ACL、EMNLP、SIGIR、NAACL、COLING、IJCAI、AAAI等学术会议或期刊发表过文章，有深度学习学术或工程项目经验优先。\n"+
      "6、了解并具备使用主流AI大模型工具；有将 LLM 集成到工作中的实践经验者优先",
    applicationMethod: "简历投递邮箱：dlhr@delilegal.com（投递时请备注：投递岗位+姓名+学校）",
  },
  {
    jobPositionType: 1, // 0 社招, 1校招实习
    jobType: 0, // 0研发 1 产品 2 市场运营
    city: 0, // 0 深圳 1其他
    title: "开发实习生",
    tip: "研发",
    sources: "校招 (实习生)",
    jobBenefits: "五险一金、节假日福利、带薪年假、定期体检、团建聚餐",
    jobResponsibilities: "软件开发",
    jobRequirements:"1、应届毕业生，计算机软件相关专业；\n"+
      "2、扎实的编程能力，熟悉java/python/javascript任意一种编程语言；\n"+
      "3、熟悉基础的数据结构与算法；\n"+
      "4、理解操作系统和数据库基础原理；\n"+
      "5、有开源组件，分布式框架相关应用经验加分。\n"+
      "6、了解并具备使用主流AI大模型工具；有将 LLM 集成到工作中的实践经验者优先",
    applicationMethod: "简历投递邮箱：dlhr@delilegal.com（投递时请备注：投递岗位+姓名+学校）",
  },
  {
    jobPositionType: 0, // 0 社招, 1校招实习
    jobType: 0, // 0研发 1 产品 2 市场运营
    city: 0, // 0 深圳 1其他
    title: "NLP算法工程师",
    tip: "研发",
    sources: "社招",
    jobBenefits: "五险一金、节假日福利、带薪年假、定期体检、团建聚餐",
    jobResponsibilities: "1、负责法律文本NLP相关处理；\n"+
      "2、负责深度语义模型搜索算法优化。\n"+
      "3、语义检索优化、大模型指令调优等相关研究任务",
    jobRequirements:
      "1、硕士及以上学历，计算机/信息工程/人工智能/软件工程/统计学/应用数学及相关专业；\n"+
      "2、熟练掌握NLP基础理论和算法，在一个或多个领域（如对话系统、文本分类自然语言生成等）能够独立开展研发工作；\n"+
      "3、熟悉至少一种编程语言（如java、python、c++等）；\n"+
      "4、熟练使用一种或多种深度学习框架（如tensorflow、pytorch等）；\n"+
      "5、在学术会议或期刊发表过文章，有深度学习学术或工程项目经验优先考虑。",
    applicationMethod: "简历投递邮箱：dlhr@delilegal.com（投递时请备注：投递岗位+姓名+学校）",
  },
  {
    jobPositionType: 0, // 0 社招, 1校招实习
    jobType: 0, // 0研发 1 产品 2 市场运营
    city: 0, // 0 深圳 1其他
    title: "搜索后台研发工程师",
    tip: "研发",
    sources: "社招",
    jobBenefits: "五险一金、节假日福利、带薪年假、定期体检、团建聚餐",
    jobResponsibilities: "1、负责搜索引擎平台相关模块的开发与运营；\n"+
      "2、优化系统稳定性、性能和吞吐量。",
    jobRequirements:"1、本科以上学历，3年以上工作经验\n"+
      "2、精通java/python至少一种开发语言\n"+
      "3、熟悉Lucene、ES等原理及相关技术\n"+
      "4、熟悉搜索引擎，对搜索引擎架构，有两年以上搜索、推荐系统开发经验\n"+
      "5、有语义匹配排序模型，机器学习排序模型，自然语言处理等搜索引擎经验者优先\n"+
      "6、了解并具备使用主流AI大模型工具进行代码生成的经验；有将 LLM 集成到工作中的实践经验者优先\n"+
      "7、良好的学习能力、沟通能力、适应能力、责任心强，能在压力下独立解决问题，具有主人翁精神。",
    applicationMethod: "简历投递邮箱：dlhr@delilegal.com（投递时请备注：投递岗位+姓名+学校）",
  },
  {
    jobPositionType: 0, // 0 社招, 1校招实习
    jobType: 0, // 0研发 1 产品 2 市场运营
    city: 0, // 0 深圳 1其他
    title: "大数据开发工程师",
    tip: "研发",
    sources: "社招",
    jobBenefits: "五险一金、节假日福利、带薪年假、定期体检、团建聚餐",
    jobResponsibilities: "1、负责分布式大数据应用平台开发与维护；\n"+
      "2、负责推荐引擎平台相关模块的开发。",
    jobRequirements:"1、本科以上学历，3年以上工作经验；\n"+
      "2、精通java/python至少一种开发语言；熟练掌握 SQL，具备良好的数据仓库理论基础和数据建模能力（如维度建模）\n"+
      "3、熟悉 spark on k8s, 大数据平台组件，有两年以上实际项目经验；对 Spark 的核心原理（如 RDD、DataFrame/Dataset、Catalyst 优化器、内存管理、Shuffle 机制）有深入理解\n"+
      "4、熟悉 Kubernetes 的核心概念（Pod, Deployment, Service, PVC/PV 等），具备 Spark on Kubernetes 的部署、配置、运维和问题排查经验。\n"+
      "5、了解并具备使用主流 AI大模型工具进行数据处理、增强、质量校验或代码生成的经验；有将 LLM 集成到数据工作流中的实践经验者优先\n"+
      "6、良好的学习能力、沟通能力、适应能力、责任心强，能在压力下独立解决问题，具有主人翁精神。",
    applicationMethod: "简历投递邮箱：dlhr@delilegal.com（投递时请备注：投递岗位+姓名+学校）",
  },
  {
    jobPositionType: 0, // 0 社招, 1校招实习
    jobType: 0, // 0研发 1 产品 2 市场运营
    city: 0, // 0 深圳 1其他
    title: "前端开发工程师",
    tip: "研发",
    sources: "社招",
    jobBenefits: "五险一金、节假日福利、带薪年假、定期体检、团建聚餐",
    jobResponsibilities: "1、负责得理相关产品的开发升级，负责从需求分析、技术方案设计到代码编写、测试与上线的全流程工作。\n"+
      "2、运用 prettier/eslint/stylelint 等 lint 工具对代码进行检测，保证代码质量。\n"+
      "3、关注行业前沿技术动态，深入研究并引入适用于公司产品的新技术、新工具，推动前端技术创新与产品升级。",
    jobRequirements:"1、拥有至少1个完整的大型项目前端开发经验，能独立承担复杂模块的开发任务并有效推动项目进展。\n"+
      "2、精通 HTML5、CSS3、JavaScript、typeScript 等前端基础技术，熟练掌握 vuejs 框架及其生态系统。\n"+
      "3、具有丰富的移动端前端开发经验，熟悉移动端浏览器兼容性问题及解决方案，熟练掌握至少一种移动端开发框架(如uni-app、Taro 等）。\n"+
      "4、熟悉前端构建工具（如 Webpack、Vite 等），能够熟练配置与优化构建流程，提升项目打包构建的效率。\n"+
      "5、熟悉前端组件库 ant-design-vue、vant、naiveUI等。\n"+
      "6、熟悉 less、sass 等 css 预处理器，以及 tailwindcss 等原子化 css。\n"+
      "7、积极乐观，责任心强，工作认真细致，具备良好的服务意识，具有良好的跨团队沟通与协作能力。\n"+
      "8、有开源项目贡献经验或个人技术博客，在技术社区有一定的影响力，能够积极分享前端开发经验与技术见解。\n"+
      "9、了解并具备使用主流AI大模型工具进行代码生成的经验；有将 LLM 集成到工作中的实践经验者优先",
    applicationMethod: "简历投递邮箱：dlhr@delilegal.com（投递时请备注：投递岗位+姓名+学校）",
  },{
    jobPositionType: 0, // 0 社招, 1校招实习
    jobType: 0, // 0研发 1 产品 2 市场运营
    city: 0, // 0 深圳 1其他
    title: "后台开发工程师",
    tip: "研发",
    sources: "社招",
    jobBenefits: "五险一金、节假日福利、带薪年假、定期体检、团建聚餐",
    jobResponsibilities: "1、负责搜索，app后台开发工作；\n"+
      "2、负责SAAS类平台产品后台开发工作。",
    jobRequirements:"1、本科以上学历，3年以上工作经验；\n"+
      "2、精通java语言，对java面向对象软件结构有一定理解；\n"+
      "3、能够熟练掌握spring等主流开发框架；\n"+
      "4、熟练使用mysql数据库，对数据库表有独立设计能力；\n"+
      "5、熟悉https协议，redis相关协议，熟悉分布式、缓存、消息等机制；\n"+
      "6、了解并具备使用主流AI大模型工具进行代码生成的经验；有将 LLM 集成到工作中的实践经验者优先\n"+
      "7、良好的学习能力、沟通能力、适应能力、责任心强，能在压力下独立解决问题，具有主人翁精神。",
    applicationMethod: "简历投递邮箱：dlhr@delilegal.com（投递时请备注：投递岗位+姓名+学校）",
  }
];
